<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <h5>{{ t("challenges-authentication-code-title") }}</h5>
        <p>{{ t("challenges-authentication-code-description") }}</p>
        <input v-model="code" type="text" :placeholder="t('challenges-authentication-code-placeholder')" :class="{ error: errorFlag }">
        <p v-if="errorFlag" class="errorMessage"><span class="icon"></span>{{ t('challenges-authentication-code-incorrect') }}<br/>{{t('learning-fail-message-retry')}}</p>
        <div class="btnArea">
          <button :disabled="!code" :class="{disabled: !code}" @click.stop="onClickVerify">{{ t("common-next") }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref } from "#imports";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { useContestService } from "~/composables/service/useContestService";
import DialogType from "~/components/Common/Dialog/model/DialogType";
import { ContestListModel } from "~~/package/mapper/contest/model/ContestListModel";

const { t } = useI18n();
const dialogStore = useDialogStore();

const router = useRouter();
const { getContestReceive } = useContestService();

const code = ref("");
const errorFlag = ref(false);
const contestData = ref<ContestListModel>(dialogStore.options.props.contest);

const onClickVerify = () => {
  if (code.value !== "") {
    useContestService().getContestAuthentication(contestData.value.id, code.value).then(isSuccess => {
      if (isSuccess) {
        dialogStore.close();
        dialogStore.open({
          type: DialogType.GuidelinePopup,
          props: {
            isAgreeToRules: true,
            contest: contestData.value,
            callBack: () => {
              getContestReceive(contestData.value.id, 1).then(isAgree => {
                if (isAgree) {
                  router.push({ path: `/contest/${contestData.value.id}/0` });
                }
              });
            }
          }
        });
      }
      errorFlag.value = !isSuccess;
    }).catch(e => {
      errorFlag.value = true;
    });
  }
};

const onClickClose = () => {
  dialogStore.close();
};

</script>

